import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown, SupTitle } from "components";
import { Hero10Content } from "types/graphql/generated";

interface Props {
  content: Hero10Content;
}

const Hero10: VFC<Props> = withErrorBoundary(({ content: { title, description, hero10SupTitle } }) => {
  return (
    <StyledHero10 className="Content">
      {hero10SupTitle && <SupTitle className="Hero10__supTitle Font_18_26_700">{hero10SupTitle}</SupTitle>}
      <div>
        <h1 className="Hero10__title Font_48_54_600 lg:Font_40_48_600">{title}</h1>
        <Markdown className="Hero10__description Color_secondary Font_24_32_450">{description}</Markdown>
      </div>
    </StyledHero10>
  );
}, {});

const StyledHero10 = styled.section`
  .Hero10__title {
    margin-top: 32px;
  }

  .Hero10__supTitle {
    &::before {
      margin-right: 16px;
    }
  }

  .Hero10__description {
    max-width: 1000px;
    margin-top: 16px;
  }
`;

gql`
  fragment Hero10Content on ComponentHeroHero10 {
    hero10SupTitle
    title
    description
  }
`;

export { Hero10 };
export type { Props as Hero10Props };
